import {
  Box,
  Grid,
  GridItem,
  Icon,
  Text,
  useRadio,
  UseRadioProps,
} from "@chakra-ui/react";
import * as React from "react";
import { FaCheckCircle, FaRegCircle } from "react-icons/fa";

type RadioCardProps = {
  children: React.ReactNode;
} & UseRadioProps;

export const RadioCard = (props: RadioCardProps) => {
  const { getInputProps, getRadioProps, state } = useRadio({ ...props });

  const input = getInputProps();
  const checkbox = getRadioProps();

  return (
    <Box as="label" cursor="pointer">
      <input {...input} />
      <Box
        {...checkbox}
        borderWidth="4px"
        borderColor="lightAccent"
        borderRadius="md"
        boxShadow="md"
        _checked={{
          borderColor: "brand.lightblue",
          color: "brand.darkblue",
        }}
        _focus={{ boxShadow: "outline" }}
        px={5}
        py={3}
        mx={2}
        width="auto"
        fontWeight="bold"
      >
        <Grid
          templateAreas={`"leadingAction leadingVisual label trailingVisual trailingAction"`}
          gridTemplateColumns="min-content min-content minmax(0, auto) min-content min-content"
          gridTemplateRows="min-content"
          alignItems="center"
        >
          <GridItem
            area="leadingVisual"
            boxSizing="border-box"
            marginRight="1rem"
            paddingTop={1}
          >
            {state.isChecked ? (
              <Icon as={FaCheckCircle} />
            ) : (
              <Icon as={FaRegCircle} opacity=".5" />
            )}
          </GridItem>
          <GridItem area="label">
            <Text>{props.children}</Text>
          </GridItem>
        </Grid>
      </Box>
    </Box>
  );
};
